/**
 * Appends the product brand to a text label when the product has one.
 * Products without a brand keep their previous label untouched.
 */
export const withBrand = (label: string, brandName?: string): string => {
  return brandName ? `${label} (${brandName})` : label;
};

/**
 * Key used to group order/transfer items into one row per product and color.
 * The code identifier is only unique per brand, so two products can share
 * code and color; the product id tells them apart. The code is kept as a
 * fallback for items whose product was deleted.
 */
export const productColorKey = (item: {
  clothingProductId?: number;
  productCodeIdentifier?: string;
  colorName?: string;
}): string => {
  const product =
    item.clothingProductId !== undefined && item.clothingProductId !== null
      ? `id:${item.clothingProductId}`
      : `code:${item.productCodeIdentifier}`;
  return `${product}-${item.colorName}`;
};
